import styled from '@emotion/styled'
import { isMobile } from '@const/device'

const DesktopH1 = styled.h1`
  font-size: ${({ theme }) => theme.text.h2.fontSize};
  line-height: ${({ theme }) => theme.text.h2.lineHeight};
  font-weight: 700;
  letter-spacing: 0;
  text-align: left;
  margin: 0;
  padding: 0;
`
const MobileH1 = styled(DesktopH1)``
export const H1 = isMobile ? MobileH1 : DesktopH1

export const H2 = styled.h2`
  font-size: ${({ theme }) => theme.text.h5.fontSize};
  line-height: ${({ theme }) => theme.text.h5.lineHeight};
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
  margin: 0;
  padding: 0;
`

export const H3 = styled.h3`
  font-size: ${({ theme }) => theme.text.h6.fontSize};
  line-height: ${({ theme }) => theme.text.h6.lineHeight};
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text.secondary};
  width: 100px;
  white-space: nowrap;
  margin: 0;
  padding: 0;
`

export const H4 = styled.h4`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  white-space: nowrap;
  margin: 0;
  padding: 0;
`

export const H1Small = styled(H1)`
  font-size: 18px;
`
